// msalConfig.js
const msalConfig = {
  auth: {
    clientId: 'cc0a0b87-9ba4-4dad-b1a5-50c0c59284bb',
    authority: 'https://login.microsoftonline.com/a2760153-5887-4d08-9fa2-78013c75bd2c',
     redirectUri: 'https://34.204.57.179/', // Change this to your actual redirect URI
    // redirectUri: 'http://localhost:3000', // Change this to your actual redirect URI
  },
  cache: {
    cacheLocation: 'localStorage', // This configures where your cache will be stored
    storeAuthStateInCookie: false, // Set this to true if you're having issues on IE11 or Edge
  },
};

export default msalConfig;
